import React, { useEffect, useState, useRef } from "react";
import CopyToClipboard from "./CopyToClipboard";
import "./CustomRag.css";
import { Container } from "react-bootstrap";
import { useAppConfig } from "../../providers/AppConfigProvider";
import useRagApi from "../../hooks/useRagApi";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Feedback from "./Feedback";
import { generateUniqueID } from "../../utility/util";
function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    console.log("totally custom!")
  );

  return (
    <strong
      style={{
        color: "#545b64",
        fontSize: "14px",
        fontFamily: "Amazon Ember, Helvetica, sans-serif",
      }}
      onClick={decoratedOnClick}
    >
      {children}
      <i className="fa-solid fa-angle-down arrow-down"></i>
    </strong>
  );
}

const CustomRag = ({ contactSet }) => {
  const [userDownState, setUserDownState] = useState({});
  const [userState, setUserState] = useState({});
  const [hiddenTextIndices, setHiddenTextIndices] = useState(false);
  const [addCounter, setAddCounter] = useState(1);
  const [currentContact, setCurrentContact] = useState(null);
  const [error, setError] = useState(null);
  const [agentQuery, setAgentQuery] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState({
    user: "",
    qid: "",
  });
  const [callNoti, setCallNoti] = useState(true);

  const {
    fecthRagResponse,
    ragResponsehistory,
    aiChatLoading,
    updateFeedback,
    rollingText,
    storeTranA,
    deleteFromStack,
    isServiceAvailable,
    agentAssistApiError,
  } = useRagApi(contactSet);

  const [agent, setAgent] = useState({
    agentLdap: "",
    agentName: "",
    channelName: "",
    sessionId: "",
  });
  const {
    selectContact,
    userSession,
    loading,
    updateSetLoading,
    updateSetShowFeedbackComp,
    showFeedbackComp,
  } = useAppConfig();

  const [chatUsers, setChatUsers] = useState([]);
  useEffect(() => {
    let channelName = "";
    window.connect.agent(function (agent) {
      const agentDetails = agent.getChannelConcurrency();
      Object.keys(agentDetails).forEach((el) => {
        if (agentDetails[el]) {
          channelName = el === "VOICE" ? "IVR" : "CHAT";
        }
      });
      const uniqueID = generateUniqueID(
        agent._getData().configuration.username,
        agent._getData().configuration.name,
        "agent"
      );
      setAgent({
        agentLdap: agent._getData().configuration.username,
        agentName: agent._getData().configuration.name,
        channelName: channelName,
        sessionId: uniqueID,
      });
    });
  }, []);

  useEffect(() => {
    if (agent.sessionId !== "") {
      setChatUsers((prevArray) => [...prevArray, agent.sessionId]);
    }
  }, [agent]);

  useEffect(() => {
    const newContact = [];
    contactSet.forEach((contact) => {
      newContact.push(contact.contactId);
    });
    if (agent.sessionId !== "") {
      setChatUsers([agent.sessionId, ...newContact]);
    }
  }, [contactSet]);

  useEffect(() => {
    if (
      userSession?.content &&
      userSession?.content !== "" &&
      userSession?.contactId !== ""
    ) {
      if (
        !userSession?.content?.includes("Device Type") &&
        !userSession?.content?.includes("OS") &&
        !userSession?.content?.includes("BROWSER") &&
        !userSession?.content?.includes("Chat Summary Details")
      ) {
        fecthRagResponse({
          content: userSession?.content,
          contactId: userSession?.contactId,
          userName: userSession.displayName,
          is_manual: false,
          channelName: agent.channelName,
        });
      }
    }
  }, [userSession]);

  useEffect(() => {
    if (contactSet.size > 0) {
      contactSet.forEach(function (val) {
        if (selectContact && selectContact === val.contactId) {
          setCurrentContact(val);
        }
      });
    } else {
      setCurrentContact("");
    }
  });

  const upVote = (user, qid) => {
    updateFeedback(user, qid, "1")
      .then((response) => {
        if (response.status === 200) {
          console.log("updateFeedback success:", response);
          handleUpVote(`${user}${qid}`);
          handleDownVoteDelete(`${user}${qid}`);
        } else {
          console.log("updateFeedback failed:", response);
        }
      })
      .catch((error) => {
        console.error("updateFeedback error:", error);
      });
  };

  useEffect(() => {
    if (!hiddenTextIndices && callNoti && Object.keys(storeTranA).length > 0) {
      setAddCounter((prevCounter) => prevCounter + 1);
    }
    setTimeout(() => {
      setCallNoti(true);
    }, 1000);
  }, [storeTranA]);

  const handleUpVote = (qid) => {
    setUserState((prevState) => ({
      ...prevState,
      [qid]: !prevState[qid],
    }));
  };
  const handleDownVote = (qid) => {
    setUserDownState((prevState) => ({
      ...prevState,
      [qid]: !prevState[qid],
    }));
  };
  const handleUpVoteDelete = (qid) => {
    if (userState[qid]) {
      const newState = { ...userState };
      delete newState[qid];
      setUserState(newState);
    }
  };

  const handleDownVoteDelete = (qid) => {
    if (userDownState[qid]) {
      const newState = { ...userDownState };
      delete newState[qid];
      setUserDownState(newState);
    }
  };

  return (
    <div
      className="canned-msg-container-rag"
      style={{ backgroundColor: "#f2f2f2" }}
    >
      <div className="p-1 container-title-rag">
        <span>Agent Assist</span>
      </div>
      <div
        className="d-flex input-group mb-3"
        style={{ maxWidth: "342px", margin: "5px auto" }}
      >
        <div
          style={{
            marginLeft: "5px",
            marginRight: "5px",
          }}
        >
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => {
              setHiddenTextIndices(!hiddenTextIndices);
              setAddCounter(0);
            }}
            disabled={
              !storeTranA.hasOwnProperty(currentContact?.contactId) ||
              storeTranA[currentContact?.contactId].length === 0
            }
          >
            {!hiddenTextIndices ? (
              <i className="fa-solid fa-angle-down"></i>
            ) : (
              <i className="fa-solid fa-angle-up"></i>
            )}
            {addCounter > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "-12px",
                  right: "-12px",
                  backgroundColor: "#b70000",
                  borderRadius: "50%",
                  color: "white",
                  textAlign: "center",
                  width: "24px",
                  height: "24px",
                  lineHeight: "24px",
                  fontSize: "12px",
                }}
              >
                {addCounter}
              </div>
            )}
          </button>
        </div>

        <input
          type="text"
          className="form-control"
          placeholder="Search for Assist"
          aria-label="Search for Assist"
          aria-describedby="button-addon2"
          value={agentQuery ? agentQuery : ""}
          onChange={(e) => setAgentQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              updateSetLoading(true);
              fecthRagResponse({
                content: agentQuery,
                contactId: agent.sessionId,
                userName: currentContact?.fName || agent.agentName,
                is_manual: true,
                channelName: agent.channelName,
              });
              setAgentQuery("");
            }
          }}
          style={{
            border: "none",
            borderRadius: "0.25rem",
            paddingLeft: "10px",
            paddingRight: "10px",
            height: "calc(1.5em + 0.75rem + 2px)",
            fontSize: "0.9rem",
          }}
        />
      </div>
      <div className="canned-response-box-rag">
        <div id="ccp-container">
          {(aiChatLoading?.[currentContact?.contactId] || loading) && (
            <div className="loader-container">
              <div className="loader"></div>
            </div>
          )}
          {error && <p>Error: {error}</p>}
          {!isServiceAvailable && (
            <div style={{ textAlign: "center" }}>
              <p style={{ color: "red" }}>Service is Temporarily Unavailable</p>
            </div>
          )}
          {agentAssistApiError && (
            <div style={{ textAlign: "center" }}>
              <p style={{ color: "red" }}>
                Service is down. Please reach out to support team.
              </p>
            </div>
          )}
          {chatUsers.map((user, index) => {
            console.log('[custom chatUsers]',chatUsers)
            let displayClass = "";
            if (contactSet.size <= 0) {
              displayClass = "";
            } else if (currentContact?.contactId !== user) {
              displayClass = "d-none";
            }
            return (
              <>
                {hiddenTextIndices &&
                  storeTranA.hasOwnProperty(user) &&
                  storeTranA[user].length > 0 && (
                    <Container
                      key={index}
                      fluid
                      className={`contact-details mb-2 ${displayClass}`}
                    >
                      <div
                        className="card custom-card p-3"
                        style={{
                          backgroundColor: "#fff",
                          borderRadius: "0px",
                          borderColor: "transparent",
                        }}
                      >
                        {storeTranA?.[user]?.slice(0, 5).map((data, key) => (
                          <div
                            key={key}
                            onClick={() => {
                              setHiddenTextIndices(!hiddenTextIndices);
                              fecthRagResponse({
                                content: data?.query,
                                contactId: data?.contactId,
                                userName: data.displayName,
                                is_manual: true,
                                channelName: agent.channelName,
                              });
                              deleteFromStack(data?.contactId, data?.query);
                              setCallNoti(false);
                            }}
                            type="button"
                            className="btn btn-warning btn-sm"
                            style={{ marginBottom: "10px" }}
                          >
                            {data.query}
                          </div>
                        ))}
                      </div>
                    </Container>
                  )}

                {rollingText?.[user] && (
                  <Container
                    fluid
                    className={`contact-details mb-2 ${displayClass}`}
                  >
                    <div
                      className="card custom-card p-3"
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: "0px",
                        borderColor: "transparent",
                      }}
                    >
                      <div>
                        <i className="fa-regular fa-user"></i>
                        <span
                          style={{
                            marginLeft: "5px",
                            fontSize: "12px",
                            color: "#545b64",
                          }}
                        >
                          {rollingText[user].name} said:
                        </span>
                        <div style={{ marginTop: "10px" }}>
                          <strong
                            style={{
                              marginTop: "10px",
                              marginLeft: "5px",
                              fontSize: "14px",
                              color: "#545b64",
                              fontFamily: "Amazon Ember, Helvetica, sans-serif",
                            }}
                          >
                            {`"${rollingText[user].query}"`}
                          </strong>
                        </div>
                      </div>
                      <hr className="mt-3 mb-3" />
                      <p
                        style={{
                          marginLeft: "5px",
                          fontSize: "14px",
                          color: "#545b64",
                          fontFamily: "Amazon Ember, Helvetica, sans-serif",
                          lineHeight: "1.5",
                        }}
                      >
                        {rollingText[user].answer}
                      </p>
                    </div>
                  </Container>
                )}
                {ragResponsehistory?.[user]?.map((responseData, key) => {
                  return (
                    <Container
                      key={key}
                      fluid
                      className={`contact-details mb-2 ${displayClass}`}
                    >
                      <div
                        className="card custom-card p-3"
                        style={{
                          backgroundColor: "#fff",
                          borderRadius: "0px",
                          borderColor: "transparent",
                        }}
                      >
                        <div>
                          <i className="fa-regular fa-user"></i>
                          <span
                            style={{
                              marginLeft: "5px",
                              fontSize: "12px",
                              color: "#545b64",
                            }}
                          >
                            {responseData.name} said:
                          </span>
                          <div style={{ marginTop: "10px" }}>
                            <strong
                              style={{
                                marginTop: "10px",
                                marginLeft: "5px",
                                fontSize: "14px",
                                color: "#545b64",
                                fontFamily:
                                  "Amazon Ember, Helvetica, sans-serif",
                              }}
                            >
                              {`"${responseData.query}"`}
                            </strong>
                          </div>
                        </div>
                        <hr className="mt-3 mb-3" />
                        <Accordion defaultActiveKey={["0"]} alwaysOpen>
                          <div style={{ cursor: "pointer" }}>
                            <CustomToggle eventKey="0">Response</CustomToggle>
                            <Accordion.Collapse eventKey="0">
                              <>
                                <div className="d-flex align-items-center justify-content-end mb-3">
                                  <div className="icons d-flex align-items-center">
                                    <CopyToClipboard
                                      text={responseData?.answer}
                                      initialContactId={user}
                                      qid={responseData.qid}
                                      isCopied={true}
                                    />

                                    <div className="feedback-icons">
                                      <div className="line"></div>
                                      <i
                                        key={`${user}${responseData.qid}up`}
                                        className={`fa-solid fa-thumbs-up aa-icon ${
                                          userState[
                                            `${user}${responseData.qid}`
                                          ]
                                            ? "clicked"
                                            : ""
                                        }`}
                                        onClick={() => {
                                          upVote(user, `${responseData.qid}`);
                                          // handleUpVote(
                                          //   `${user}${responseData.qid}`
                                          // );
                                          // handleDownVoteDelete(
                                          //   `${user}${responseData.qid}`)
                                        }}
                                      ></i>
                                      <i
                                        key={`${user}${responseData.qid}down`}
                                        className={`fa-solid fa-thumbs-down aa-icon ${
                                          userDownState[
                                            `${user}${responseData.qid}`
                                          ]
                                            ? "clicked"
                                            : ""
                                        }`}
                                        onClick={(event) => {
                                          setCurrentQuestion({
                                            user: user,
                                            qid: `${responseData.qid}`,
                                          });
                                          updateSetShowFeedbackComp(true);
                                          handleDownVote(
                                            `${user}${responseData.qid}`
                                          );
                                          handleUpVoteDelete(
                                            `${user}${responseData.qid}`
                                          );
                                        }}
                                        style={{ marginLeft: "5px" }}
                                      ></i>
                                    </div>
                                    {showFeedbackComp && (
                                      <div className="popup-overlay">
                                        <div className="popup-content">
                                          <Feedback
                                            initialContactId={
                                              currentQuestion.user
                                            }
                                            qid={currentQuestion.qid}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <p
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "14px",
                                    color: "#545b64",
                                    fontFamily:
                                      "Amazon Ember, Helvetica, sans-serif",
                                    lineHeight: "1.5",
                                  }}
                                >
                                  {responseData?.answer}
                                </p>
                              </>
                            </Accordion.Collapse>
                          </div>
                          <hr className="mt-3 mb-3" />
                          <div style={{ cursor: "pointer" }}>
                            <CustomToggle eventKey="1">Citations</CustomToggle>
                            <Accordion.Collapse eventKey="1">
                              <div
                                style={{
                                  marginTop: "10px",
                                  marginLeft: "5px",
                                  fontSize: "14px",
                                  color: "#545b64",
                                  fontFamily:
                                    "Amazon Ember, Helvetica, sans-serif",
                                  lineHeight: "1.5",
                                }}
                              >
                                {responseData?.citation_data.map(
                                  (data, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        marginBottom: "10px",
                                      }}
                                    >
                                      {data}
                                    </div>
                                  )
                                )}
                              </div>
                            </Accordion.Collapse>
                          </div>
                          <hr className="mt-3 mb-3" />
                          <div style={{ cursor: "pointer" }}>
                            <CustomToggle eventKey="2">
                              Referenced Files
                            </CustomToggle>
                          </div>
                          <Accordion.Collapse eventKey="2">
                            <div
                              style={{
                                marginTop: "10px",
                                marginLeft: "5px",
                                fontSize: "14px",
                                lineHeight: "1.5",
                              }}
                            >
                              {responseData?.metadata.map((file, index) => (
                                <div key={index} className="mb-6">
                                  <a
                                    href={`https://docs.google.com/gview?url=https://d3u2s6c6uj6idz.cloudfront.net/knowledge-base/documents/${file.name}&embedded=true`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {file.name}
                                  </a>
                                </div>
                              ))}
                            </div>
                          </Accordion.Collapse>
                        </Accordion>
                      </div>
                    </Container>
                  );
                })}
              </>
            );
          })}
          {
            <>
              <Container fluid className={`contact-details mb-2`}>
                <div
                  className="card custom-card p-3"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "0px",
                    borderColor: "transparent",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <i
                      className="fa-regular fa-star"
                      style={{ marginRight: "10px" }}
                    ></i>
                    <strong
                      style={{
                        marginRight: "10px",
                        color: "#545b64",
                        fontSize: "14px",
                        fontFamily: "Amazon Ember, Helvetica, sans-serif",
                      }}
                    >
                      Agent Assist
                    </strong>
                  </div>
                  <div
                    style={{
                      marginTop: "10px",
                      marginLeft: "5px",
                      fontSize: "14px",
                      color: "#545b64",
                      fontFamily: "Amazon Ember, Helvetica, sans-serif",
                      lineHeight: "1.5",
                    }}
                  >
                    <strong>Hello I am Agent Assist, your AI assistant!</strong>
                    <br />
                    <span>
                      As I listen to the conversation I will provide
                      suggestions.
                    </span>
                  </div>
                </div>
              </Container>
            </>
          }
        </div>
      </div>
    </div>
  );
};

export default CustomRag;
